import React from 'react';
import PropTypes from 'prop-types';
import Word from './Word';
import {
    getRepeatedWordClassName,
    isWordRepeated,
    isIncorrectWord,
} from '../../../../../utils/shared/trcUtils';
import { COLORS } from '../../../../../constants/shared/CommonConstants';
import { MSV } from '../../../../../constants/shared/TrcConstants';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const { ORANGE, GREEN } = COLORS;

const renderDot = (word, nextWord) => (
    <span className={`central-point ${getRepeatedWordClassName(word, nextWord)}`}>.</span>
);

const renderMSVSymbols = (wordData, nextWordData, mainColor, msvPropName) => (
    <div className={`msv-symbol ${getRepeatedWordClassName(wordData, nextWordData)}`}>
        {MSV.map(item => (
            <div
                key={generateReactKey(item)}
                className={wordData.msv[`${msvPropName}${item}`] ? mainColor : 'gray'}
            >
                {item.toLowerCase()}
            </div>
        ))}
    </div>
);

const renderMSVComponent = (wordData, nextWordData) => {
    const sc = wordData.selfCorrected;
    return (
        <div
            className={`msv-container ${
                isWordRepeated(wordData, nextWordData) ? '' : 'msv-padding'
            }`}
        >
            {isIncorrectWord(wordData) && renderMSVSymbols(wordData, nextWordData, ORANGE, 'error')}
            {sc && renderMSVSymbols(wordData, nextWordData, GREEN, 'sc')}
        </div>
    );
};

const Paragraph = ({ number, words, baseUrl }) => (
    <div key={number} className="paragraph-container">
        <span className="paragraph-style">p.{number}.</span>
        {words.map((wordObject, index, arr) => {
            const { word, repetitionStarted, repetitionEnded, msv, firstWordInLine } = wordObject;
            const nextWord = arr[index + 1];
            return (
                <div key={generateReactKey(index, word)} className="word-container">
                    {repetitionStarted && <div className="repeat-left-icon" />}
                    {firstWordInLine && renderDot(wordObject, nextWord)}
                    <Word word={wordObject} nextWord={nextWord} baseUrl={baseUrl} />
                    {msv && !msv.empty && renderMSVComponent(wordObject, nextWord)}
                    {repetitionEnded && (
                        <div className="repeat-right-icon">
                            <i className="icon-amplify-close" />
                        </div>
                    )}
                </div>
            );
        })}
    </div>
);

Paragraph.defaultProps = {
    number: 0,
    words: [],
    baseUrl: null,
};

Paragraph.propTypes = {
    number: PropTypes.number,
    words: PropTypes.array,
    baseUrl: PropTypes.string,
};

export default Paragraph;
